var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.form.title))]),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.form.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }